import { NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { FeathericonsModule } from '../icons/feathericons/feathericons.module';
import { UserService } from '../services/api-services/user.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-request-access',
  standalone: true,
  imports: [MatButtonModule, MatInputModule, ReactiveFormsModule, MatFormFieldModule, MatCardModule,
    NgIf, FeathericonsModule, RouterModule],
  templateUrl: './request-access.component.html',
  styleUrl: './request-access.component.scss'
})
export class RequestAccessComponent implements OnInit {
  accessForm: FormGroup = new FormGroup({});

  infoText = '';
  showSuccessText = false;

  constructor(private fb: FormBuilder, private apiService: UserService) {
  }

  ngOnInit() {
    this.accessForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
    this.showSuccessText = false;
    this.infoText = '';
  }

  requestAccess() {
    if (this.accessForm.get('email') !== null) {
      this.apiService.requestAccess(this.accessForm.get('email')?.value).subscribe({
        error: error => {
          if (!environment.production) {
            console.log(error);
          }
          if (error.status === 400) {
            if (error.error && error.error.message.startsWith('An account')) {
              this.infoText = 'An account has been found having this email.';
              this.showSuccessText = true;
            } else if (error.error.message.startsWith('Incorrect')) {
              this.infoText = 'The provided email has an incorrect format. Please try again.';
              this.showSuccessText = true;
            }
          }
          this.accessForm.reset();
        },
        complete: () => {
          this.infoText = 'Access request sent successfully. We will send you an email in the following days.';
          this.showSuccessText = true;
          this.accessForm.reset();
        }
      })
    } else {
      window.alert('An error occured while trying to fetch email. Please try again or contact an administator.');
    }
  }
}
